import React from 'react';

export function NotificationItem({ tenant, property, message, time, type, unread }) {
  // Get initials from tenant name
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className={`flex items-start gap-3 p-3 rounded-lg ${unread ? 'bg-blue-50 border border-blue-100' : 'bg-gray-50'}`}>
      <div className="w-10 h-10 bg-[#7F8C8D] rounded-full flex items-center justify-center text-white text-sm font-medium flex-shrink-0">
        {getInitials(tenant)}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between">
          <h4 className="font-semibold text-[#2C3E50] text-sm">{tenant}</h4>
          {unread && (
            <span className="w-2 h-2 bg-[#3498DB] rounded-full flex-shrink-0"></span>
          )}
        </div>
        <p className="text-xs text-[#E74C3C]">{property}</p>
        <p className="text-sm text-[#2C3E50] mt-1 truncate">{message}</p>
        <p className="text-xs text-[#7F8C8D] mt-1">{time}</p>
      </div>
    </div>
  );
}

export default NotificationItem;
